import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n/config";
import "./index.css";

// Remove SSR shell immediately to prevent layout shift when React hydrates
const ssrShell = document.getElementById("ssr-shell");
if (ssrShell) ssrShell.remove();

createRoot(document.getElementById("root")!).render(<App />);
